<template>
  <div class="moduleFive">
    <div style="display: flex;justify-content: space-between;">
      <div style="display: flex;">
        <div style="margin-top:15px">效果图:</div>
        <img
          :src="peitu"
          width="50px"
          @click="dialogVisible = true"
          height="50px"
        />
        <el-dialog title="效果图" :visible.sync="dialogVisible">
          <img :src="peitu" width="100%" height="100%" />
        </el-dialog>
      </div>
    </div>
    <div class="logo">
      <div class="div">图片:</div>
      <el-upload
        class="avatar-uploader"
        action="/api/file/upload"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
        accept="image/png, image/jpeg"
        name="uploadFile"
      >
        <img
          v-if="data.joinFindDto ? data.joinFindDto.img : false"
          :src="data.joinFindDto ? data.joinFindDto.img : ''"
          class="avatar"
        />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>
    <div>
      是否显示上传简历：
      <el-switch
        v-model="data.joinFindDto.resume"
        active-color="#13ce66"
        inactive-color="#ff4949"
      >
      </el-switch>
    </div>
    <div class="logo" style="line-height: 20px;display:flex">
      <div class="div" style="line-height: 93px;width:100px">文字说明:</div>
      <ckeditor
        style="line-height: 20px;width:80%"
        :editor="editor"
        v-model="data.joinFindDto.description"
        :config="editorConfig"
      ></ckeditor>
    </div>
    <div class="addmodule" style="display: flex;justify-content: flex-end;">
      <el-button
        type="primary"
        style="display:flex;border-radius: 10px 10px 0px 0px;"
        @click="add()"
        >添加</el-button
      >
    </div>
    <div>
      <el-table :data="data.joinListFindDtos" row-key="id" border stripe>
        <el-table-column prop="name" label="标题名称" width="200">
          <template slot-scope="scope">
            <el-input
              v-model="data.joinListFindDtos[scope.$index].name"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="标题类型">
          <template slot-scope="scope">
            <div style="display: flex">
              <el-select
                @change="select(scope.row)"
                v-model="data.joinListFindDtos[scope.$index].type"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
              <div
                style="display: flex"
                v-if="data.joinListFindDtos[scope.$index].type === 2"
              >
                <div
                  v-if="data.joinListFindDtos[scope.$index].type === 2"
                  style="display:flex"
                >
                  <el-select v-model="qwe">
                    <el-option
                      v-for="(item, index) in data.joinListFindDtos[
                        scope.$index
                      ].content"
                      :key="index"
                      :value="item"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="data.joinListFindDtos[scope.$index].wtf"
                  ></el-input>
                  <el-button @click="chooseValue(scope.$index)">
                    添加值
                  </el-button>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="age" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              style="border:0px"
              @click="deleteRow(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import selecte from "./selecte";
export default {
  data() {
    return {
      qwe: "",
      setData: "",
      child: "",
      data: {
        joinFindDto: {
          img: "",
          description: ""
        },
        joinListFindDtos: []
      },

      dialogImageUrl: require("@/assets/logo.png"),
      peitu: require("@/assets/logo.png"),
      dialogVisible: false,
      // 文本编辑器
      editor: ClassicEditor,
      editorConfig: {
        removePlugins: ["MediaEmbed"], //除去视频按钮
        language: "zh-cn", //中文包
        toolbar: [
          "heading", //段落
          "|", //分隔
          "bold", //加粗
          "italic", //倾斜
          "link", //超链接
          "bulletedList", //项目列表
          "numberedList", //编号列表
          "blockQuote", //块引用
          "undo", //撤销
          "redo" //重做
        ] //工具栏显示
      },
      options: [
        {
          value: 1,
          label: "输入框"
        },
        {
          value: 2,
          label: "选择框"
        }
      ],
      message: ""
    };
  },
  components: {
    // selecte
  },
  props: {
    openModule: {
      default: []
    }
  },
  watch: {
    openModule: {
      handler(val) {
        console.log("1`23123321", val);
        if (val.length) this.getMassage();
      },
      deep: true,
      immediate: true
    },
    data: {
      handler: function(val) {
        console.log("123123123123", val);
        this.$emit("getModule", val);
      },
      deep: true
    }
  },
  methods: {
    chooseValue(index) {
      if (!this.data.joinListFindDtos[index].content)
        this.data.joinListFindDtos[index].content = [];
      var qaq = this.data.joinListFindDtos[index].wtf;
      console.log(qaq);
      if (qaq) {
        this.data.joinListFindDtos[index].content.push(qaq);
        this.data.joinListFindDtos[index].wtf = "";
      }
    },
    getMassage() {
      if (this.openModule.length) {
        console.log(this.openModule[0], "3333333333333333333333  B>>C");
        this.data.joinListFindDtos = this.openModule[0].joinListFindDtos;
        this.data.joinFindDto = this.openModule[0].joinFindDto;
      }
    },
    handleAvatarSuccess(res) {
      this.imageUrl = res.data.fileurl;
      this.data.joinFindDto.img = res.data.fileurl;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 效果图查看
    look() {
      this.dialogVisible = true;
    },
    select(row) {
      console.log(row, "row");
      if (row.type === "1") {
        this.data.joinListFindDtos = [];
      }
    },
    // 添加模块
    add() {
      this.data.joinListFindDtos.push({});
    },
    // 删除
    deleteRow(index) {
      this.data.joinListFindDtos.splice(index, 1);
    },
    addqwe() {
      console.log(1);
    }
  }
};
</script>

<style lang="sass">
.moduleFive
  .logo
    display: flex
    padding: 20px 20px 0 20px
    line-height: 93px
    .div
      padding-right: 10px
    .amplify
      width: auto
      height: 100px
  .addmodule
    padding: 15px 0 15px 23px
  .el-input__inner
    width: 220px
  .avatar-uploader .el-upload
    border: 1px dashed #d9d9d9
    border-radius: 6px
    cursor: pointer
    position: relative
    overflow: hidden
    .avatar-uploader .el-upload:hover
      border-color: #409EFF
    .avatar-uploader-icon
      font-size: 28px
      color: #8c939d
      width: 100px
      height: 100px
      line-height: 100px
      text-align: center
    .avatar
      width: 100px
      height: 100px
      display: block
</style>
